

const images = {
  userAvatarPlaceholderUrl: "https://dwze8aajmsi4h.cloudfront.net/v3/x/missing-1712ff297225e8a523a3b0f2f47e76b15f826bde1cefd31e12f3884f6a848d0a.png"
}

export default images
